import React, { useState } from 'react';
import '../CSS/styles.css';
import { Link, useParams } from 'react-router-dom';
import { galleriesBySlug } from '../galleryData';

const DetailView = () => {
  const { index } = useParams();
  const gallery = galleriesBySlug[index];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loadedImages, setLoadedImages] = useState(() => new Set());
  const [failedImages, setFailedImages] = useState(() => new Set());

  if (!gallery) {
    return (
      <section
        className='not-found-page gallery-not-found-page'
        aria-labelledby='gallery-not-found-title'>
        <div className='not-found-content'>
          <p className='not-found-code' aria-hidden='true'>
            404
          </p>
          <p className='not-found-kicker'>Outside the frame</p>
          <h1 id='gallery-not-found-title'>Gallery not found</h1>
          <p className='not-found-message'>
            This gallery may have moved, changed, or is no longer part of the
            collection.
          </p>
          <div className='not-found-actions'>
            <Link className='btn btn-dark' to='/portrait'>
              View photography
            </Link>
            <Link className='btn btn-outline-dark' to='/'>
              Back home
            </Link>
          </div>
        </div>
      </section>
    );
  }

  const { folder, images } = gallery;
  const currentImage = images[currentIndex];

  const markImageLoaded = src => {
    setLoadedImages(previous => new Set(previous).add(src));
  };

  const markImageFailed = src => {
    setFailedImages(previous => new Set(previous).add(src));
  };

  const handleMainImageClick = () => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % images.length);
  };

  const handleThumbnailClick = thumbIndex => {
    setCurrentIndex(thumbIndex);
  };

  return (
    <div className='detailview-container'>
      <div className='main-image-wrapper' onClick={handleMainImageClick}>
        {failedImages.has(currentImage.src) && (
          <div className='main-image-error' role='status'>
            Photograph unavailable
          </div>
        )}
        <img
          src={currentImage.src}
          alt={`${folder} portrait ${currentIndex + 1}`}
          className={`main-image ${
            loadedImages.has(currentImage.src) ? 'is-loaded' : ''
          }`}
          onLoad={() => markImageLoaded(currentImage.src)}
          onError={() => markImageFailed(currentImage.src)}
        />
      </div>
      <div className='thumbnails-wrapper'>
        {images.map((img, idx) => (
          <img
            key={img.name}
            src={img.src}
            alt={`Thumb ${idx + 1}`}
            className={`thumbnail ${
              loadedImages.has(img.src) ? 'is-loaded' : ''
            } ${idx === currentIndex ? 'active' : ''}`}
            onLoad={() => markImageLoaded(img.src)}
            onError={() => markImageFailed(img.src)}
            onClick={() => handleThumbnailClick(idx)}
          />
        ))}
      </div>
    </div>
  );
};

export default DetailView;
